module.exports = __webpack_public_path__ + "img/img_size1_jf.0ddad860.png";